import { apiAdapter } from "../components/JoinUs/DialogPostulation/adapter-postulation-form";
import { API_URL, token } from "../constants/config";

export async function getFormPostulationTexts(locale: string) {
  const localeParam = locale === "en" ? `&locale=${locale}` : "";
  const url = `${API_URL}hr-form?populate=*${localeParam}`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return apiAdapter(data, locale);
  } catch (error) {
    return apiAdapter({}, locale);
  }
}

export async function uploadFile(file: File) {
  const url = `${API_URL}upload/`;
  const formData = new FormData();
  formData.append("files", file);
  try {
    const response = await fetch(url, {
      method: "post",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error sending form data:", error);
    throw error;
  }
}

export async function sendFormContact(formData: any) {
  const url = `${API_URL}hr-form-answers`;
  try {
    if (formData.data.cv instanceof File) {
      const uploadResponse = await uploadFile(formData.data.cv);
      formData.data.cv = uploadResponse[0].id;
    }
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error sending form data:", error);
    throw error;
  }
}
